import { AuthGuard } from '../../../shared/services';
import { CagnottesDetailsResolver } from '../cagnottes-details/cagnottes-details.resolver';
import { CagnottesViewComponent } from './cagnottes-view.component';
import { Route } from '@angular/router';

export const CagnottesViewRoutes: Route[] = [
    {
        path: 'view/:id',
        component: CagnottesViewComponent,
        canActivate: [AuthGuard],
        resolve: {
            data: CagnottesDetailsResolver
        }
    }
];
